import type { ConversationsResponse, ConversationResponse } from './types'
import api from '.'

export interface ConversationsParams {
  page: number
  outcome?: string
  stage?: string
  search?: string
  channel?: string
  prompt_versions?: string[]
}

export async function getConversations(
  params: ConversationsParams,
): Promise<ConversationsResponse> {
  const res = await api.get<ConversationsResponse>('/conversations', { params })
  return res.data
}

export async function getConversation(
  id: string,
): Promise<ConversationResponse> {
  const res = await api.get<ConversationResponse>(`/conversations/${id}`)
  return res.data
}

export async function setConversationOverride(
  id: string,
): Promise<{ agent_override: boolean }> {
  const res = await api.post<{ agent_override: boolean }>(
    `/conversations/${id}/override`,
  )
  return res.data
}

export async function sendAgentMessage(
  id: string,
  content: string,
): Promise<void> {
  await api.post(`/conversations/${id}/agent-message`, { content })
}
